import React from 'react';
import ExecuteSearch from "../../../assets/undraw/execute_search.svg";
import './styles.scss';

interface Props {
    text:string
}

function PlaceholderSearch({ text }:Props) {
    return (
        <div className='placeholder-search'>
            <img alt="search" src={ExecuteSearch}/>
            <div className='text'>
                {text}
            </div>
        </div>
    )
}

export default PlaceholderSearch;